import { render } from "./p-address-input.vue?vue&type=template&id=57ea8634&scoped=true"
import script from "./p-address-input.vue?vue&type=script&lang=js"
export * from "./p-address-input.vue?vue&type=script&lang=js"

import "./p-address-input.vue?vue&type=style&index=0&id=57ea8634&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ea8634"],['__file',"src/components/p-address-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57ea8634"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57ea8634', __exports__)) {
    api.reload('57ea8634', __exports__)
  }
  
  module.hot.accept("./p-address-input.vue?vue&type=template&id=57ea8634&scoped=true", () => {
    api.rerender('57ea8634', render)
  })

}


export default __exports__